import { ReactElement, useEffect, useState } from 'react';
import gridStyles from '@pages/forms/Grid.module.scss';
import { iInstalmentFormValues } from '@services/InstalmentService';
import { getValidFilesConfig } from '@api/index';

import { FormType } from '@constants';
import { Button, FileUploadGroup, LimitedTextAreaLarge, VFModalSimple } from '@components';
import { Field, useFormikContext } from 'formik';
import styles from './InstalmentStep7.module.scss';

function InstalmentStep7(): ReactElement {
  const { values }: { values: iInstalmentFormValues; touched: any } = useFormikContext();
  const context = useFormikContext();

  const [isCloseApplication, setIsCloseApplication] = useState(false);
  const [fileDescrption, setFilesDescription] = useState('You may upload a maximum of 5 files; each file should be less than 4MB.');
  const [fileSizeLimit, setFileSizeLimit] = useState('4');
  const [fileNumberLimit, setFileNumberLimit] = useState(5);

  useEffect(() => {
    const getFileInfo = async (): Promise<void> => {
      getValidFilesConfig().then((responseBody) => {
        if (responseBody) {
          const instalmentData = responseBody.find((response) => response.FormType === FormType.INSTALMENT);
          if (instalmentData?.Description) {
            setFilesDescription(instalmentData?.Description);
          }
          if (instalmentData?.FileSize) {
            setFileSizeLimit(Math.floor(instalmentData?.FileSize / 1000000).toString());
            context.setFieldValue('FileSizeLimitUpfrontPayment', Math.floor(instalmentData?.FileSize / 1000000).toString());
            // INVALID_FILE_SIZE_ERROR_MESSAGE = `Sorry, this file is either too large (must be less than ${fileSizeLimit} MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.`;
          }
          if (instalmentData?.MaxAttachments) {
            setFileNumberLimit(parseInt(instalmentData.MaxAttachments, 10));
          }
        }
      });
    };
    getFileInfo();
  }, []);

  const closeModal = () => {
    setIsCloseApplication(false);
  };
  const clickContinueApplication = () => {
    // window.scrollTo(0, 1200);
    context.setFieldValue('isStep7ContinueApplicationClicked', true);
  };
  const navigateToHomePage = () => {
    window.location.href = '/';
};
  const closeModalInformation = (): ReactElement => (
    <div>
      <p className={styles.errorMessageQuestion}>Are you sure you want to close this form?</p>
      <div className={styles.errorMessageButtons}>
        <Button onClick={closeModal} color="blue" size="small_medium">
          No
        </Button>
        <Button onClick={navigateToHomePage} color="blue" size="small_medium">
          Yes
        </Button>
      </div>
      <br />
    </div>
  );
  const titleText = 'Close this application';

  return (
    <div className={gridStyles.form}>
      <span className="vfH2">Upfront payment required</span>
      <p>
        An upfront payment of
        {' '}
        <strong>
          $
          {(0.20 * parseFloat(values.TotalPaymentArrangementAmount)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </strong>
        {' '}
        will be required before setting up this payment arrangement.
      </p>
      <span>
        Please call us on
        {' '}
        <a href="tel:0392008222" title="Fines Victoria phone number">
          03 9200 8222
        </a>
        {' '}
        or
        {' '}
        <a href="tel:1300369819" title="Fines Victoria phone number">
          1300 369 819
        </a>
        {' '}
        (regional callers). We are available Monday to Friday, from 8am to 6pm (except public holidays).
      </span>
      <p>
        Quote your obligation number
        {' '}
        <strong>{values.OBLIGATION_NUMBER}</strong>
        {' '}
        when you call.
      </p>
      <p>
        If you have dealt with your application over the phone, you can
        {' '}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */}
        <a className={styles.modalLink} onClick={() => setIsCloseApplication(true)}>
          close this application
        </a>
        .
      </p>
      {isCloseApplication && <VFModalSimple show close={closeModal} title={titleText} content={closeModalInformation()} />}
      {!values.isStep7ContinueApplicationClicked && (
        <div className={styles.button_container}>
          <Button onClick={clickContinueApplication} color="blue" size="medium">Continue</Button>
        </div>
      )}
      {values.isStep7ContinueApplicationClicked
      && (
      <div>
        <Field
          className={styles.largeTextBox}
          component={LimitedTextAreaLarge}
          name="DetailsForUpfrontPaymentCircumstances"
          value={values.DetailsForUpfrontPaymentCircumstances}
          limit={3000}
          title="If you continue with this online application, we will contact you to make an upfront payment. If you cannot afford the upfront payment, please provide the reasons and attach any supporting evidence. Maximum 3000 characters."
        />
        <p>
          Attach any supporting documents (
          {fileDescrption}
          ). If supporting documents are not provided, your application may not be successful.
          <span className={styles.optional}> ( optional )</span>
        </p>
        <Field
          component={FileUploadGroup}
          uploadAReport="SupportingDocUpfrontPaymentNameField"
          uploadFieldArrayName="SupportingDocumentsUpfrontPayment"
          whoPrepared="SupportingDocUpfrontPaymentFilesProvider"
          briefDescription="SupportingDocUpfrontPaymentFilesDescription"
          fileSizeErrorField="SupportingDocUpfrontPaymentFieldErrorHandle"
          fileUploadFailErrorField="SupportingDocUpfrontPaymentFileUploadErrorHandle"
          UploadFileSectionError="SupportingDocUpfrontPaymentUploadFileSectionError"
          fileSizelimit={fileSizeLimit}
          totalFileLimit={fileNumberLimit}
          hasPrepared={false}
          hasDescribe={false}
          formType={FormType.INSTALMENT}
        />
      </div>
      )}
    </div>
  );
}

export default InstalmentStep7;
